export default __webpack_public_path__ + "static/media/b2bFirstName.25d8444b.png";